import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const parking = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getAvailableParkings() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/parkings/names`)
  },
  getParkings () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/parkings`)
  },
  addParking (parking) {
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${parking.siteId}/parkings`, parking)
  },
  editParking (parking) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${parking.siteId}/parkings/${parking.id}`, parking)
  },
  getSitesWithParkings() {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/sites/parkings`)
  },
  getAllParkingsGroupedBySite (clientId) {
    const client = clientId ? clientId : this.getClientId()
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${client}/sites/parkings`)
  },
  getParkingDevices (parkingId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/parkings/${parkingId}/devices`)
  },
  saveParkingDevices (parkingId, devicesIds) {
    const body = { parkingId: parkingId, devicesIds: devicesIds }
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/parkings/${parkingId}/devices`, body)
  },
  activateParking (parking) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${parking.site.id}/parkings/${parking.id}/activate`, {
      ignoreGlobalCatch: true,
    })
  },
  deactivateParking (parking, cancelFutureBookings) {
    return Axios
      .patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${parking.site.id}/parkings/${parking.id}/deactivate?cancelFutureBookings=${cancelFutureBookings}`, {
        ignoreGlobalCatch: true,
      })
  },
  getParkingIntegration (parkingId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/parkings/${parkingId}/integrations`)
  },
  saveIntegration (parkingId, integration) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/parkings/${parkingId}/integrations`, integration)
  },
}

export default parking
